export default "__VITE_ASSET__CNbi_EwE__"